<template>
  <div class="content-blocks-table-component">
    <div class="filters mb-4 d-flex flex-wrap align-items-end">
      <div class="form-group me-3 mb-25">
        <label for="search" class="me-2">Search</label>
        <input v-model="search" type="text" class="form-control" id="search" @keyup.enter="getContentBlocks()"
               :disabled="loading">
      </div>

      <button @click="getContentBlocks()" type="button" class="btn btn-primary mb-25" :disabled="loading">
        Search
      </button>

      <button v-if="filters" @click="resetFilters()" type="button" class="ms-3 mb-25 btn btn-danger">Reset Filters
      </button>

      <a href="/admin/content_blocks/create" class="ms-3 mb-25 btn btn-success">Create</a>

      <div v-if="loading" class="ms-3 mb-25 spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>

    <div class="table-responsive">
      <table class="table table-hover">
        <thead>
        <tr>
          <th>ID</th>
          <th>Name</th>
          <th>Created</th>
          <th>Updated</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="contentBlock in contentBlocks.data" :key="contentBlock.id">
          <td>{{ contentBlock.id }}</td>
          <td>{{ contentBlock.name }}</td>
          <td>{{ contentBlock.created_at | moment("llll") }}</td>
          <td>{{ contentBlock.updated_at | moment("llll") }}</td>
          <td><a :href="'/admin/content_blocks/' + contentBlock.id + '/edit'" class="btn btn-sm btn-primary">Edit</a>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <nav>
      <pagination :data="contentBlocks" @pagination-change-page="getContentBlocks" :limit="5"></pagination>
    </nav>
    <p class="text-muted">Found a total of {{ Number(contentBlocks.total).toLocaleString() }} result(s).</p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      search: null,
      page: 1,
      contentBlocks: null,
      filters: null,
    };
  },

  props: {
    preloadContentBlocks: {
      type: Object,
      default: null,
    },
  },

  created() {
    this.contentBlocks = this.preloadContentBlocks;

    // Load get params.
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('filters[search]')) {
      this.search = urlParams.get('filters[search]');
    }

    this.setFilters();
  },

  methods: {
    setFilters() {
      if (this.search !== null) {
        this.filters = {
          search: this.search,
        };
      } else {
        this.filters = null;
      }
    },

    handlePushState() {
      let pageUrl = '?';

      // Add filters.
      for (const filter in this.filters) {
        if (this.filters[filter] === null) {
          continue;
        }

        if (pageUrl !== '?') {
          pageUrl += '&';
        }

        pageUrl += `filters[${filter}]=${encodeURIComponent(this.filters[filter])}`;
      }

      // Add page number.
      if (this.page > 1) {
        pageUrl += '&page=' + this.page;
      }

      window.history.pushState('', '', pageUrl);
    },

    getContentBlocks(page = 1) {
      this.loading = true;
      this.page = page;
      this.setFilters();

      this.handlePushState();

      axios.post(`${window.api_url}/admin/content_blocks/get`, {
        page: this.page,
        filters: this.filters,
      })
        .then(res => {
          this.contentBlocks = res.data.content_blocks;
        })
        .catch(err => {
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    resetFilters() {
      this.search = null;
      this.getContentBlocks();
    },
  },
};
</script>
